import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { GetCustomerAbandonedCartSlice } from "../../redux/features/AbandonedCartManagmentSlice";
import { Loader } from "../../common/Loader/Loader";
import useParamsFormat from "../../common/Params Values format/ParamsFormat";
import { toast } from "react-toastify";
import Pagination from "../../common/pagination/PaginationCustom";

const AbandonedCartManagment = () => {
  const dispatch = useDispatch();

  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState([]);
  const [handleArrforPage, setHandleArrforPage] = useState(1);
  const [arr, setArr] = useState([]);
  const [page, setPage] = useState(1);
  const [getSearch, setGetSearch] = useState({
    search: "",
    fromDate: "",
    toDate: "",
    page: 1,
  });
  const {createDataSetParams} = useParamsFormat();

  const { loading } = useSelector((state) => state.AbandonedCartManagment);

  useEffect(() => {
    dispatch(GetCustomerAbandonedCartSlice()).then((res) => {
      if (
        Array.isArray(res?.payload?.data?.cart) &&
        res?.payload?.data?.cart?.length > 0
      ) {
        setData(res?.payload?.data?.cart);
        setPagination(res.payload.data?.pagination);
      }
    });
  }, []);

    useEffect(() => {
      if (Object.entries(pagination ?? {}).length > 0) {
        setArr(
          [...Array(pagination?.totalPages + 1).keys()]
            .slice(1)
            .slice(handleArrforPage - 1, handleArrforPage + 2) 
        );
      }
    }, [pagination, handleArrforPage]);

  const handlePagesIncrease = () => {
    console.log("handleIncrease:", handleArrforPage);
    if (handleArrforPage + 3 <= pagination?.totalPages) {
      setHandleArrforPage((prev) => prev + 3);
    }
  };

  const handlePagesDecrease = () => {
    if (handleArrforPage > 2) {
      setHandleArrforPage((prev) => prev - 3);
    }
  };

  const FetchDataOnPages = (pageNum) => {
    setPage(pageNum);

    setGetSearch((prev) => ({ ...prev, page: pageNum }));

    const dataSet = createDataSetParams({ ...getSearch, page: pageNum });

    dispatch(GetCustomerAbandonedCartSlice(dataSet)).then((res) => {
      const dummyData = res?.payload?.data;
      setData(dummyData);
      setPagination(res.payload.data?.pagination);
    });
  };

  const HandleSearch = () => {
    //search=hello&fromDate=2024-12-05&toDate=2024-12-19&
    if (
      Object.entries(getSearch)
        .map(([key, value]) => value.length)
        .some((item) => item > 0)
    ) {
      if (
        ![getSearch.fromDate.length, getSearch.toDate.length].every(
          (item) => item === 0
        )
      ) {
        if (
          ![getSearch.fromDate.length, getSearch.toDate.length].every(
            (item) => item > 0
          )
        ) {
          toast.error("Please complete the date!");
          return;
        }
      }

      dispatch(
        GetCustomerAbandonedCartSlice(createDataSetParams(getSearch))
      ).then((res) => {
        const dummyData = res?.payload?.data;
        setData(dummyData);
        setPagination(res.payload.data?.pagination);
      });
    }
  };

  const HandleReset = () => {
    if (
      Object.entries(getSearch)
        .map(([key, value]) => value.length)
        .some((item) => item > 0)
    ) {
      setGetSearch({
        search: "",
        fromDate: "",
        toDate: "",
        page: 1,
      });

      dispatch(GetCustomerAbandonedCartSlice()).then((res) => {
        console.log("newsres", res);
        const dummyData = res?.payload?.data;
        setData(dummyData);
        setPagination(res.payload.data?.pagination);
      });
    }
  };

  return (
    <>
      <>
        <div className="WrapperArea">
          <div className="WrapperBox">
            <div className="Small-Wrapper">
            <div className="Filter">
                <div className="form-group">
                  <label>Search</label>
                  <input
                    type="search"
                    className="form-control"
                    placeholder="Search"
                    name="search"
                    value={getSearch?.search}
                    onChange={(e) =>
                      setGetSearch((prev) => ({
                        ...prev,
                        [e.target.name]: e.target.value,
                      }))
                    }
                  />
                </div>
                <div className="form-group">
                  <label>From Date</label>
                  <input
                    type="date"
                    className="form-control"
                    name="fromDate"
                    value={getSearch?.fromDate}
                    onChange={(e) =>
                      setGetSearch((prev) => ({
                        ...prev,
                        [e.target.name]: e.target.value,
                      }))
                    }
                  />
                </div>
                <div className="form-group">
                  <label>To Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={getSearch?.toDate}
                    name="toDate"
                    onChange={(e) =>
                      setGetSearch((prev) => ({
                        ...prev,
                        [e.target.name]: e.target.value,
                      }))
                    }
                  />
                </div>
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button className="Button" style={{marginRight:'10px'}} onClick={HandleSearch}>
                    Apply
                  </button>

                  <button
                    className="Button Cancel"
                    onClick={HandleReset}
                  >
                    <i className="fa fa-refresh" />
                  </button>
                </div>
              </div>
            </div>
            <div className="TableList">
              <table style={{ width: "100%" }}>
                <thead>
                  <tr>
                    <th>S.No.</th>
                    <th>Customer Id</th>
                    <th>Customer Name</th>
                    <th>Contact Details</th>
                    <th>View Cart</th>
                    {/* <th>Action</th> */}
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <Loader />
                  ) : Array.isArray(data) && data.length > 0 ? (
                    data?.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item?.customerDetails?.customerId}</td>
                          <td>{item?.customerDetails?.personalInfo?.name}</td>
                          <td>{item?.customerDetails?.phone}</td>
                           <td>
                            <div className="Actions">
                              <Link
                                className="Blue"
                                to={"AbandonedDetails"}
                                state={item} 
                              >
                                <i className="fa fa-eye" />
                              </Link>
                            </div>
                          </td>
                        {/*<td>
                            <span className="Green">Notify</span>
                          </td> */}
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={10}>There is no data found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <Pagination
                arr={arr}
                page={page}
                handlePagesIncrease={handlePagesIncrease}
                FetchDataOnPages={FetchDataOnPages}
                handlePagesDecrease={handlePagesDecrease}
              />
          </div>
        </div>
        <div className="ModalBox">
          <div
            id="DeleteModal"
            className="modal fade"
            style={{ display: "none" }}
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-body">
                  <div className="Decline">
                    <a
                      href="javascript:void(0);"
                      className="CloseModal"
                      data-dismiss="modal"
                    >
                      ×
                    </a>
                    <h3>Delete</h3>
                    <p>Are you sure you want to Delete this category ?</p>
                    <h4>
                      <a href="javascript:void(0);" data-dismiss="modal">
                        no
                      </a>
                      <a href="javascript:void(0);" data-dismiss="modal">
                        Yes
                      </a>
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            id="NotificationAdd"
            className="modal fade"
            aria-hidden="true"
            style={{ display: "none" }}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-body">
                  <div className="Category">
                    <a
                      href="javascript:void(0);"
                      className="CloseModal"
                      data-dismiss="modal"
                    >
                      ×
                    </a>
                    <h3>List of Sub-category</h3>
                    <div className="form-group">
                      <label>Sub-category Name</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter category name"
                      />
                    </div>
                    <div className="form-group">
                      <label>Upload Images</label>
                      <div className="UploadBox">
                        <div className="Upload">
                          <i className="fa fa-upload" /> <span>Upload</span>
                          <input type="file" />
                        </div>
                      </div>
                    </div>
                    <a href="#" className="Button">
                      Save
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="NotificationEdit" className="modal fade" role="dialog">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-body">
                  <div className="Category">
                    <a
                      href="javascript:void(0);"
                      className="CloseModal"
                      data-dismiss="modal"
                    >
                      ×
                    </a>
                    <h3>List of Sub-category</h3>
                    <div className="form-group">
                      <label>Sub-category Name</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter category name"
                      />
                    </div>
                    <div className="form-group">
                      <label>Upload Images</label>
                      <div className="UploadBox">
                        <div className="Upload">
                          <i className="fa fa-upload" /> <span>Upload</span>
                          <input type="file" />
                        </div>
                      </div>
                    </div>
                    <a href="#" className="Button">
                      Save
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="ModalBox">
          <div
            id="LogOutModal"
            className="modal fade"
            style={{ display: "none" }}
            aria-hidden="true"
          ></div>
        </div>
      </>
    </>
  );
};

export default AbandonedCartManagment;
